import React from "react";
import { useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Loading from "../../components/UI/Loading";

const ErCanvas = ({
  children,
  show,
  onClose,
  name,
  loading,
  board,
  rowDataId,
  links,
  childBoardId =''
}) => {
  const [isCopied, setIsCopied] = useState(false);
  const params = useParams();
  const databoardId = childBoardId ? `${childBoardId}` : `${params.id}_${rowDataId}`;
  return (
    <Offcanvas
      show={show}
      placement="end"
      onHide={onClose}
      className="my-canvas"
    >
        <Offcanvas.Header closeButton className="pb-2 pt-2 border-bottom">
        <Offcanvas.Title>
          {board && `${board} : ${databoardId ?? ''} `}
          {name && !board && name}
          {links && (
            <span
              className={`copy_link ${isCopied ? "showiscopied" : ""}`}
              onClick={() => {
                navigator.clipboard.writeText(
                  `${window.location.origin}${links}`
                );
                setIsCopied(true);
                setTimeout(() => {
                  setIsCopied(false);
                }, 800);
              }}
            >
              <svg
                width="20"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5a3.375 3.375 0 00-3.375-3.375H9.75"
                />
              </svg>
            </span>
          )}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="pt-2">{children}</Offcanvas.Body>
    </Offcanvas>
  );
};

export default ErCanvas;
